import moment from "moment";
import React from "react";

const GetUpdatedOnBy = ({ updatedAt, updatedBy }) => {
  if (!updatedAt || !updatedBy) {
    return null; // Return null if no data is available
  }
  return (
    <div
      style={{
        display: "flex",
        alignItems: "flex-start",
        gap: "25%",
        paddingBottom: "10px",
        paddingTop: "10px",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
        <div>Updated On</div>
        <div>{moment(updatedAt).format("MMM DD, YYYY, h:mm A")}</div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
        <div>Updated By</div>
        <div style={{ fontSize: "1em" }}>{`${updatedBy.firstName} ${updatedBy.lastName}`}</div>
        <div style={{ fontSize: "0.8em", color: "#666" }}>{updatedBy.email?.toLowerCase()}</div>
      </div>
    </div>
  );
};
export default GetUpdatedOnBy;
